import * as variables from './variables.js';

import './lib/AnimationEasing';

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu .menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 600, 'easeOutCirc')
	]
});
// NOTE: mainMenu is not currently collapsing on size reduction

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});


/* Silky smooth scrolling */
import SmoothScroll from './lib/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
mySmoothScroll.add('main a[href*="#"]', {
	duration: 1200,
	easing: 'easeOutCirc'
});


// To make Repairs/Returns printable
import PrintableForm from  './component/PrintableForm';
new PrintableForm();


// @ts-ignore
import './lib/Testimonials';

var inPageNav = function(){
	const element = document.querySelector('#inpageNav');
	if (element){
		const headings = document.querySelectorAll('.pageContent h2, .pageContent h3, .pageContent h4');
		if (headings){
			const idMaker = function(str: String){
				return str.toLowerCase().replace(/\s/gi, '-');
			}
			const createLI = function(id,text){
				let li = document.createElement('li');
				let a = document.createElement('a');
				a.href = "#" + id;
				a.text = text;
				li.appendChild(a);
				return li;
			}
			const ul = document.createElement('ul');
			for (let i=0;i<headings.length;i++) {
				let item = headings[i] as HTMLElement;
				let id = idMaker(item.innerText);
				item.id = id;
				ul.appendChild( createLI(id,item.innerText) );
			}
			element.appendChild(ul);
		}
	}
};
inPageNav();
